/*
 * *
 *   ~  * Copyright (c) by INFODATA-GROUP. All rights reserved.
 *   ~  * No part of this publication may be reproduced, distributed,
 *   ~  * or transmitted in any form or by any means, including photocopying, recording,
 *   ~  * or other electronic or mechanical methods, without the prior written permission of the publisher,
 *   ~  * except in the case of brief quotations embodied in critical
 *   ~  * reviews and certain other noncommercial uses permitted by copyright law.
 *   ~  * AUTHOR : bs
 *   ~  * DATE : 20/05/2025 14:16
 *
 */

import { Component, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActionEvent, StandardAction } from '@infodata-group/inf-commons';
import { HeaderComponent } from '@infodata-group/inf-commons-mobile';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'infl-page-mobile',
  standalone: true,
  imports: [CommonModule, HeaderComponent, TranslatePipe],
  templateUrl: './page-mobile.component.html',
  styleUrl: './page-mobile.component.scss',
})
export class PageMobileComponent {
  public headerActions = input<StandardAction[]>([]);
  public headerTitle = input<string>('');

  public withMenu = input<boolean>(true);

  public headerActionClick = output<ActionEvent>();
  public showTitle = input<boolean>(false);
  public titleIcon = input<string>(null);
}
